import { Avatar, Tooltip } from '@mantine/core';

import logoConfig from 'config/logos';
import { toTitleCase } from 'helpers/format.cuboh';

import MarketplacePosLogo from './MarketplacePosLogo';

interface SourceAvatarProps {
  tooltipLabel?: string;
  source: string;
  size?: string;
  withToolTip?: boolean;
}

// Logo px per avatar size — the brand mark sits inside the circle with padding
// (e.g. 20px in a 24px "sm" circle, 30px in a 40px "lg" circle) per design.
const LOGO_SIZE: Record<string, number> = {
  xs: 12,
  sm: 20,
  md: 24,
  lg: 30,
};

export default function SourceAvatar({
  tooltipLabel = '',
  source,
  size = 'md',
  withToolTip = false,
}: SourceAvatarProps) {
  const sourceKey = source.toLowerCase();
  const hasLogo = sourceKey in logoConfig;
  const label = tooltipLabel || source;
  const logoSize = LOGO_SIZE[size] ?? 20;

  const avatar = (
    <Avatar size={size} variant="ink" name={hasLogo ? '' : sourceKey.charAt(0)}>
      {hasLogo && <MarketplacePosLogo source={sourceKey} variant="white" size={logoSize} />}
    </Avatar>
  );

  if (withToolTip) {
    return (
      <Tooltip position="top" label={toTitleCase(label)} w="auto">
        {avatar}
      </Tooltip>
    );
  }

  return avatar;
}
